/* eslint-disable */
// @ts-nocheck

import { useContext, useState } from 'react'

import {
  ArrowUturnLeftIcon,
  PencilSquareIcon,
} from '@heroicons/react/24/outline'

import Button from '../../../../../components/misc/Button'
import Modal from '../../../../../components/modals/GenericModal'
import { translateMeasure } from '../../../../../utils/translate'
import {
  DispatchProductContext,
  FieldProductData,
  VisualData,
} from './ProductMovementStep'
import QuantitySelector from './QuantitySelector'
import VariationProductContainer from './VariationProductContainer'

export default function ReceivedList() {
  const { fields, remove } = useContext(DispatchProductContext)
  const [modal, setModal] = useState<FieldProductData | null>(null)
  const [variationModal, setVariationModal] = useState<VisualData | null>(null)

  const products: VisualData[] = []

  fields!.forEach((item) => {
    const idx = products.findIndex((elem) => elem.id === item.productId)
    if (idx !== -1) {
      const product: VisualData = {
        ...products[idx],
        available: item.available + products[idx].available,
        quantity: item.quantity + products[idx].quantity,
        variations: [
          ...products[idx].variations,
          {
            id: item.variationId,
            available: item.available,
            name: item.variationName,
            quantity: item.quantity,
          },
        ],
      }
      products.splice(idx, 1, product)
    } else {
      products.push({
        id: item.productId,
        productId: item.productId,
        available: item.available,
        measure: item.measure,
        name: item.productName,
        quantity: item.quantity,
        variations: item.variationId
          ? [
              {
                id: item.variationId,
                name: item.variationName,
                available: item.available,
                quantity: item.quantity,
              },
            ]
          : [],
      })
    }
  })

  const removeItem = (id: number) => {
    const indexes: number[] = []
    fields!.forEach((item, idx) => {
      if (item.productId === id) {
        indexes.push(idx)
      }
    })
    remove!(indexes)
  }

  const editItem = (item: VisualData) => {
    if (item.variations.length !== 0) {
      setVariationModal(item)
    } else {
      const data: FieldProductData = {
        available: item.available,
        measure: item.measure,
        productName: item.name,
        productId: item.productId,
      }
      setModal(data)
    }
  }

  return (
    <>
      {products.map((item, idx) => {
        return (
          <div
            className={`my-2 inline-flex w-full items-center rounded-md border border-slate-200 p-5 hover:bg-slate-50`}
            key={idx}
          >
            <div className="flex flex-grow flex-col">
              <span className="inline-flex items-center justify-start">
                <Button
                  action={() => removeItem(item.id)}
                  color="slate"
                  icon={
                    <ArrowUturnLeftIcon className="h-5 w-5 text-slate-500" />
                  }
                  outline
                />
                <Button
                  action={() => editItem(item)}
                  color="slate"
                  icon={<PencilSquareIcon className="h-5 w-5 text-slate-500" />}
                  outline
                />
              </span>
            </div>
            <div className="flex flex-shrink flex-col">
              <div className="inline-flex justify-end gap-5">
                <p className="text-md text-end font-semibold">{item.name}</p>
                <p className="block text-end text-sm text-slate-400">
                  {item.quantity + ' ' + translateMeasure(item.measure)}
                </p>
              </div>

              {item.variations.map((variation, idx) => (
                <div
                  className="inline-flex justify-end gap-5 pl-2 text-sm text-gray-400"
                  key={idx}
                >
                  <p>{variation.name}</p>
                  <p>{`${variation.quantity} ${translateMeasure(
                    item.measure
                  )}`}</p>
                </div>
              ))}
            </div>
          </div>
        )
      })}
      {modal && (
        <Modal close={() => setModal(null)} state={!!modal}>
          <QuantitySelector close={() => setModal(null)} productData={modal} />
        </Modal>
      )}
      {variationModal && (
        <Modal close={() => setVariationModal(null)} state={!!variationModal}>
          <VariationProductContainer
            close={() => setVariationModal(null)}
            product={variationModal}
          />
        </Modal>
      )}
    </>
  )
}
